module.exports = __webpack_public_path__ + "img/cover-product-mob.a5ce265.webp";